
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 288"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 256h32v32H0zM32 224h32v32H32zM64 224h32v32H64zM96 224h32v32H96zM128 224h32v32h-32zM96 160h32v32H96zM128 160h32v32h-32zM64 128h32v32H64zM32 96h32v32H32zM32 64h32v32H32zM192 96h32v32h-32zM192 64h32v32h-32zM64 32h32v32H64zM160 32h32v32h-32zM96 0h32v32H96zM128 0h32v32h-32zM160 128h32v32h-32zM160 224h32v32h-32zM192 224h32v32h-32zM224 256h32v32h-32z"}})])
          )
        }
      }
    